{
  "en": {
    "aiConverter": {
      "alerts": {
        "dialog": {
          "format": "Please mark the two speakers with **Name**: at the beginning of the line."
        },
        "example": "Would you like to see an example?",
        "truncatedText": "Your source exceeds the limit of {limit} characters and cannot be processed in full length."
      },
      "buttons": {
        "reuse": "Reuse",
        "transform": "Transform",
        "limitReached": "Limit reached",
        "submitForKind": {
          "audio": "Read Text Aloud",
          "dialog": "Create dialog",
          "lecture": "Create Keynote Speech",
          "podcast": "Create Podcast",
          "summary": "Create Summary",
          "text": "Extract Text from Image or File",
          "transcript": "Create Transcript",
          "translation": "Text Translation"
        }
      },
      "confirm": {
        "deleteDocument": {
          "text": "This action cannot be undone. The document will be permanently removed from your history.",
          "title": "Delete document?"
        }
      },
      "example": {
        "audio": {
          "text": "Most of us think of penguins as being a polar species, more at home on the ice of Antarctica than the sandy beaches, grassy fields and hills of the Falklands. But these incredible islands in the South Atlantic are home to five species of these fantastic flightless birds. The Falklands’ sandy shores are home to the largest population of gentoo penguins in the world – more than 121,000 pairs were counted here during the last census in 2010! Living on the Falklands all year round, the 76-cm-tall birds are easy to recognise because of the white bar that stretches across the top of their heads, and their bright orange bills. Super-fast in the sea, they swim at up to 36kmph as they dive for fish. Then, when it’s time for them to return to land, they ride the breakers before stumbling onto the beach. Back in 1971 there were just 31 breeding pairs of king penguins at Volunteer Green on East Falkland island, but today there are more than 1,500 – it’s the second-largest and most accessible colony of king penguins in the world. Fortunately, that’s where we’re visiting! Thousands of the metre-tall kings are standing together, their young close by at various stages of development. Some adults have pear-shaped white eggs resting on their feet, others have newborn grey chicks nestled between their belly feathers. Older chicks have grown their brown fluffy down, which looks a bit like sheep’s wool. We listen to the raucous call of the adults as they point their bills to the sky and trumpet, advertising their presence. It’s as if the upright, elegant adults are posing for photos, their beautiful orange-yellow necks and bills glowing in the sunshine. Source: https://www.natgeokids.com/uk/discover/animals/birds/penguins-of-the-falkland-islands/"
        },
        "dialog": {
          "dialog": "Enter your dialogue here, marking the speakers with **Name/Role**: at the beginning of the line.",
          "text": "**Host**: Hello! What is your name?\n**Guest**: My name is Anna. And you?\n**Host**: My name is Max. Nice to meet you.\n**Guest**: And you!"
        },
        "lecture": {
          "prompt": "Focus on the history and political background of Ukraine and explain it to a group of students in year 11.",
          "url": "https://en.wikipedia.org/wiki/Ukraine"
        },
        "podcast": {
          "prompt": "Give examples that are relevant to young people (12-14 years old) who are interested in TikTok and sports.",
          "url": "https://thewanderbug.com/itinerary-5-days-new-york-city-first-time/"
        },
        "summary": {
          "url": "https://www.nationalgeographic.com/animals/article/robotic-tutor-singing-birds-study",
          "prompt": "Focus on key findings for students in grade 10"
        },
        "transcript": {
          "url": "https://www.youtube.com/watch?v=FfSbWc3O_5M"
        },
        "translation": {
          "text": "Elefanten leben in Herden. Dazu gehören aber nur Kühe und Jungtiere, keine erwachsenen Bullen. So eine Herde wird von einer erfahrenen Elefanten-Kuh angeführt. Die Kuh beschützt die Gruppe, indem sie zeigt, dass sie notfalls auch angreifen würde: Sie breitet ihre Ohren weit aus und erhebt den Rüssel hoch. Die ausgewachsenen Bullen leben meistens allein oder in Gruppen, die sich immer wieder auflösen und neu zusammensetzen. Nur zur Paarung nähern sie sich den Herden der Kühe. Elefanten ernähren sich rein vegetarisch. Am liebsten fressen sie Gras und Blätter, sonst aber auch Äste und andere Pflanzen. Sie brauchen täglich etwa 200 Kilogramm davon. Dazu trinken sie über 100 Liter Wasser. Elefanten schlafen weniger lang als Menschen. Sie brauchen die ganze Zeit, um zu fressen. Dazu müssen sie auch sehr weit laufen. Sie sind zwar langsam, aber sehr ausdauernd. Deshalb ist es schwierig, Elefanten in einem Zoo zu halten, weil es dort für sie schnell zu eng ist. Bei großer Hitze und um ihre Haut zu pflegen nehmen sie auch gerne mal ein Bad oder sie spritzen sich mit dem Rüssel Wasser über den Rücken. Bei Hitze fächeln sie mit ihren Ohren und können sich so etwas Kühlung verschaffen. (Quelle: https://klexikon.zum.de/wiki/Elefanten)"
        }
      },
      "headings": {
        "config": "Source Configuration",
        "input": "What would you like to do?",
        "output": "Result"
      },
      "help": {
        "website": "Example: https://fobizz.com/en/ai-assistance-fobizz-tools/"
      },
      "hints": {
        "audio": "Note: You can upload a file directly by dragging and dropping it here. We support .mp3, .mp4, .mp4a oder .wav files up to {limit}MB.",
        "copyright": "Note: Make sure that copyrights are respected when using third-party content.",
        "image": "Note: You can upload a file directly by dragging and dropping it here. We support .jpeg, .png files up to {limit}MB.",
        "materialGeneration": "Creating material...",
        "noInputKindSelected": "Please select an input kind.",
        "pdf": "Upload a supported document up to {limit}MB: PDF, Word, PowerPoint, Excel, OpenDocument, text, Markdown, CSV, or HTML.",
        "processingProgressMessage": "Converting text to audio...",
        "submitting": "Conversion is running",
        "text": "Hint: You can enter up to 5000 characters.",
        "video": "Note: You can upload a file directly by dragging and dropping it here. We support .mp4, .mp4v, .avi or .mkv files up to {limit}MB."
      },
      "labels": {
        "additionalInfo": "Additional info and target group",
        "dialog": "Dialog input",
        "language": "Language",
        "outputLanguage": "Output language",
        "outputText": "Output text",
        "source": "Source",
        "text": "Text input",
        "transcript": "Transcript",
        "url": "URL",
        "voice": "Voice",
        "voicePlural": "Voices",
        "secondVoice": "Second voice"
      },
      "links": {
        "download": "Download",
        "openInChat": "Open in AI Chat"
      },
      "materialExports": {
        "assistant": "AI Assistant",
        "classroom_screen": "Teaching Board",
        "pinboard": "Pinboard",
        "survey": "Survey",
        "text_document": "Text document",
        "web_page": "Web page",
        "worksheet": "Worksheet"
      },
      "sourceKinds": {
        "audio": "Audio",
        "dialog": "Dialog",
        "lecture": "Lecture",
        "podcast": "Podcast",
        "summary": "Summary",
        "text": "Text",
        "transcript": "Transcript",
        "translation": "Translation"
      },
      "options": {
        "inputKinds": {
          "audio": {
            "icon": "bi-file-music",
            "title": "Audio File"
          },
          "image": {
            "icon": "bi-file-image",
            "title": "Image"
          },
          "pdf": {
            "icon": "bi-file-earmark-text",
            "title": "File"
          },
          "text": {
            "icon": "bi-file-text",
            "title": "Text"
          },
          "video": {
            "icon": "bi-film",
            "title": "Video File"
          },
          "website": {
            "icon": "bi-globe",
            "title": "Website"
          },
          "youtube": {
            "icon": "bi-youtube",
            "title": "YouTube"
          }
        },
        "languages": {
          "auto": "Auto detect"
        }
      },
      "paragraphs": {
        "voiceDefaultText": "Hello, how are you? I am your fobizz AI assistant."
      },
      "placeholders": {
        "additionalInfo": "If necessary, add information about the target audience and highlight content aspects that are particularly important to you.",
        "website": "Enter the URL of the website here..."
      },
      "statusMessages": {
        "combine_audio_chunks": "Combining audio chunks {progress}%",
        "extract_text": "Extracting text...",
        "generate_audio_file": "Generating audio {progress}%",
        "generate_dialog": "Generating dialog {progress}%",
        "generate_lecture": "Generating lecture...",
        "generate_podcast": "Generating podcast...",
        "processing_text_chunks": "Processing text chunks {progress}%",
        "summarize_text": "Summarizing text...",
        "translate_text": "Translating text...",
        "video_downloading": "Downloading video {progress}%",
        "video_processing": "Processing video {progress}%"
      }
    }
  }
}
